import { IdentifiableObject } from '@data/common/IdentifiableObject';
import { FullName } from '../interface/FullName';
import { Transform, Type } from 'class-transformer';
import { DateUtil } from '@shared/util/date.util';
import { PsychologistDTO } from '@data/common/PsychologistDTO';
import { Sex } from '@data/common/Sex';
import { PhoneNumberDTO } from '@data/common/PhoneNumberDTO';

export class AccountDTO extends IdentifiableObject implements FullName {
  public firstName: string;

  public lastName: string;

  public email: string;

  public gender: Sex;

  public hasToBookTriage: boolean;

  public hasToCompletePersonalData: boolean;

  public hasToCompleteTutorial: boolean;

  public hasUnreadMessages: boolean

  public hasConfirmedReferral: boolean;
  public requiresTokenRefresh: boolean;

  public bsn: number;

  @Transform(DateUtil.dateConversion)
  public createdDate: Date;

  @Transform(DateUtil.dateConversion)
  public birthdate: Date;

  @Type(() => PsychologistDTO)
  public assignedPsychologist: PsychologistDTO;

  @Type(() => PsychologistDTO)
  public assignedCoPsychologist: PsychologistDTO;

  @Type(() => PhoneNumberDTO)
  public phoneNumber: PhoneNumberDTO;
}